import { AmmoIndicator } from '@components/game/AmmoIndicator';
import { LootInfo } from '@components/game/LootInfo';
import { useEffect, useState } from 'react';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';

export function PlayerStats() {
  const [shield, setShield] = useState(100);
  const [health, setHealth] = useState(100);
  const [maxShield, setMaxShield] = useState(100);
  const [maxHealth, setMaxHealth] = useState(100);
  const [reloadProgress, setReloadProgress] = useState(0);
  const [showLootInfo, setShowLootInfo] = useState(false);

  const shieldPad = 50 - shield / maxShield / 2 * 100;
  const healthPad = 50 - health / maxHealth / 2 * 100;

  const onPlayerSync = (message: Shared.PlayerSyncMessage) => {
    const id = useAppStore.getState().id;
    if (!id.startsWith(message.id)) return;

    setShield(message.shield);
    setHealth(message.health);

    setMaxShield(message.maxShield);
    setMaxHealth(message.maxHealth);
  };

  useEffect(() => {
    Shared.MessageRegistry.emitter.on(Shared.PlayerSyncMessage.Opcode, onPlayerSync);
    return () => {
      Shared.MessageRegistry.emitter.off(Shared.PlayerSyncMessage.Opcode, onPlayerSync);
    };
  }, []);

  return (
    <>
      <LootInfo onClose={() => setShowLootInfo(false)} open={showLootInfo} />

      <div className="relative">
        <div onClick={() => setShowLootInfo(true)} className="ps-container">
          <AmmoIndicator onProgress={setReloadProgress} />
          <div className="flex-1">
            <div style={{ marginTop: '-1px' }} className="flex font-bold">
              <p className="ps-shield-text">{shield}</p>
              <p className="ps-health-text">{health}</p>
            </div>
            <div className="ps-bar-container">
              <div style={{ right: '50%', left: `${shieldPad}%` }} className="ps-shield-bar" />
              <div style={{ left: `${50 + healthPad}%` }} className="ps-health-bar" />
            </div>
          </div>
        </div>

        {reloadProgress > 0 && (
          <div style={{ width: `${100 - reloadProgress * 100}%` }} className="ps-reload-bar" />
        )}
      </div>
    </>
  );
}